import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ButtonM, Content, Section, TextDiv } from "../styles/Common";
import { styled } from "styled-components";
import OnlyHeaderLayout from "../components/layout/OnlyHeaderLayout";
import Guide from "../styles/images/img_partners_guide.png";
import OnePageLayout from "../components/layout/OnePageLayout";

const PartnersGuidePage = () => {
  return (
    <OnlyHeaderLayout title="제휴 안내">
      <Section className="minPaddingTop">
        <Content>
          <IntroduceTextDiv>
            <div>
              <p>
                MOSTUP Alliance 회원사에 가입하기
                <br />
                위해서는 법인회원 가입을 먼저 하셔야 합니다.
              </p>
            </div>
            <ImgWrap>
              <img src={Guide} alt="" />
            </ImgWrap>
            <MoreWrap>
              <p>
                PC를 통해 MOSTUP Alliance 회원사에
                <br />
                먼저 가입해주세요.
              </p>
              <More>
                <p
                  onClick={() => {
                    window.open(process.env.REACT_APP_SIGN_UP_URL, "_blank");
                  }}
                  className="col pointer"
                >
                  법인 회원가입 링크 바로가기
                </p>
              </More>
            </MoreWrap>
          </IntroduceTextDiv>
        </Content>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default PartnersGuidePage;

const IntroduceTextDiv = styled(TextDiv)`
  font-size: 1.6rem;
  p {
    line-height: 2rem;
    letter-spacing: -0.48px;
    font-family: NanumSquareB;
  }
`;

const ImgWrap = styled.div`
  margin-top: 5rem;
  img {
    width: 23.3rem;
  }
`;
const MoreWrap = styled.div`
  margin-top: 5rem;
  padding-bottom: 5rem;
`;
const More = styled.div`
  margin-top: 1.3rem;
  p {
    font-family: NanumSquareB;
    font-size: 1.4rem;
    line-height: 2rem;
    letter-spacing: -0.42px;
    text-decoration-line: underline;
  }
`;
